import { MatchList } from 'ui/components/company/patterns/MatchList/MatchList';

/**
 * 売り手業者マッチング一覧
 */
export const CompanyMatchList: React.FC = () => {
    return <MatchList />;
};
